import { getVendorWordSingular, VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';

import cx from 'classnames';

import styles from './lowSupplyCard.module.less';

type LowSupplyCardProps = React.HTMLAttributes<HTMLElement> & {
  taxonomyKey: VendorTaxonomyKey;
  showEditPreferences: () => void;
};
export const LowSupplyCard = ({
  taxonomyKey,
  showEditPreferences,
  className,
  ...rest
}: LowSupplyCardProps) => {
  const vendorType = getVendorWordSingular(taxonomyKey);

  return (
    <div className={cx(styles.lowSupplyCard, className)} {...rest}>
      <H.Title4 className={styles.hed}>Want more recs?</H.Title4>
      <P.BodyBase className={styles.dek}>
        Try updating your {vendorType} preferences or request recs for another category.
      </P.BodyBase>

      <LinkV2 role="button" onClick={showEditPreferences} noTextTransform>
        Edit your preferences
      </LinkV2>
    </div>
  );
};
